import { EngagementVelocity, type SocialBriefItemType } from '@inference.engine/widgets/web';

export const SOCIAL_BRIEF_ITEM_MOCK: SocialBriefItemType = {
  brandName: 'Chevrolet',
  overview: {
    opportunityTitle:
      "Leverage Viral Excitement Around 2026 Chevy Corvette ZR1X Hybrid's Hypercar Performance",
    opportunityDescription:
      "Create content and engagement campaigns that highlight the Corvette ZR1X's specs, tech, and value versus exotic brands. Use influencer reviews, owner testimonials, and interactive Q&A sessions to deepen engagement with car enthusiasts aged 30-50.",
    trendSummary: {
      title: '2026 Chevy Corvette ZR1X Hybrid: Supercar Democratization',
      dateDetected: 'July 17, 2025',
      description:
        "The 2026 Chevy Corvette ZR1X Hybrid is generating massive excitement on Reddit for its 1,250 HP, all-wheel drive, and hypercar-level specs at a much lower price point. Enthusiasts are praising GM's innovation, performance, and value, with many expressing amazement at the technological leap and performance stats. This is a prime moment to showcase Chevy's engineering leadership to car owners and performance fans.",
      sourceLinks: ['https://reddit.com/comments/1ldnz1w'],
    },
    whyMattersToBrand: {
      brandRelevance:
        "The positive sentiment and viral excitement position Chevy as an innovator in the performance and hybrid vehicle space. Engaging this audience can reinforce Chevy's leadership and attract new buyers in a key demographic.",
      insightReasonings: [],
    },
    trendOrigin: {
      trendInsight: '',
      sources: {},
      engagement: {
        velocity: EngagementVelocity.peaking,
        breakdown: {
          likes: 0,
          comments: 0,
          replies: 0,
          shares: 0,
          views: 0,
          total: 0,
        },
        rate: 0,
        velocityRate: 0,
      },
    },
  },
  customerUnderstanding: {
    targetAudienceOrDemandSpace: [
      'Performance car enthusiasts, ages 30-50',
      'Male and female car owners seeking innovation and value',
      'Hybrid and supercar segment fans',
    ],
    culturalContext: [
      'Reddit car communities',
      'Supercar and hypercar comparison culture',
      'Influencer and YouTube car reviews',
    ],
  },
  brandContext: {
    brandMentions: [
      {
        label: 'Chevy Corvette ZR1X Hybrid',
        description:
          "Highlighted for its 1,250 HP, AWD, and sub-2-second 0-60 mph time, with praise for GM's technological achievement.",
        source: 'https://reddit.com/comments/1ldnz1w',
      },
    ],
    competitiveMentions: [
      {
        label: 'Exotic supercar brands (e.g., Ferrari, Lamborghini)',
        description:
          'ZR1X is compared favorably for performance and price versus exotic supercars.',
        source: 'https://reddit.com/comments/1ldnz1w',
      },
    ],
    keyMessages: [
      {
        label: 'Performance and Innovation',
        description:
          "Chevy is redefining what's possible in the hybrid supercar space, delivering hypercar specs at an attainable price.",
        source: 'https://reddit.com/comments/1ldnz1w',
      },
    ],
    toneOfVoice: {
      styles: ['Excited', 'Confident', 'Aspirational', 'Tech-forward'],
      creativeGuidance: [
        'Emphasize performance specs with bold visuals and dynamic motion',
        'Highlight real owner reactions and influencer reviews',
        'Draw direct, positive comparisons to exotic brands',
        'Keep messaging accessible but aspirational',
      ],
    },
  },
  measurementActivation: {
    platformRecommendation: {
      primary: 'Reddit',
      secondary: 'Instagram Reels, TikTok',
      rationales: [
        'Reddit is the origin of the discussion and home to engaged car enthusiast communities',
        'Instagram Reels and TikTok are ideal for visually showcasing performance, tech, and influencer/owner reactions',
      ],
    },
    assumptionsOrFlags: [
      'Ensure all specs and claims are accurate and approved by legal/comms',
      'Secure influencer and owner participation for testimonials',
    ],
    assetTypeNeeds: [
      'Short-form video content',
      'Dynamic performance highlight reels',
      'Influencer and owner testimonial videos',
      'Q&A livestreams',
    ],
  },
  creativeBriefSnapshot: {
    suggestedMessagingStarters: [
      '1,250 HP. Sub-2-second 0-60. The new Corvette ZR1X Hybrid is here to change the game.',
      'Why pay more for a badge? Get hypercar performance, Chevy value.',
      'Hear what real owners and influencers are saying about the ZR1X Hybrid.',
    ],
    recommendedFormats: [
      'Short-form video (Reels, TikTok)',
      'Reddit AMA or Q&A threads',
      'Influencer/owner testimonial spots',
      'Performance stat highlight graphics',
    ],
    references: [
      'Reddit post: 2026 Chevy Corvette ZR1X Hybrid Packs 1250 HP and All-Wheel Drive (https://reddit.com/comments/1ldnz1w)',
    ],
    citationTags: [
      {
        label: 'Corvette ZR1X Reddit discussion',
        url: 'https://reddit.com/comments/1ldnz1w',
      },
    ],
  },
};
